import { View } from "binder"
import { UnitMultiSelectorViewModel } from "../../units/unitMultiSelector";
import { ProductEditorViewModel } from "./productEditor-viewModel"
import { ProductGroupSelectorViewModel } from "../../productGroup/productGroupSelector/productGroupSelector-viewModel";
import { ProductTypeSelectorViewModel } from "../productTypeSelector";

export class ProductEditorView extends View<ProductEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-1575B037-3D63-4536-8AE8-BAB257292104"
    }
    loadHtml(): string {
        let element = require('./productEditor.html').default;
        let style = require('./productEditor.less');
        return element;
    }
    constructor() {
        super();
    }


    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set secondaryCode(v: string) { this._secondaryCode = v; } public get secondaryCode(): string { return this._secondaryCode; } private _secondaryCode: string;
    public set imageUrl(v: string) { this._imageUrl = v; } public get imageUrl(): string { return this._imageUrl; } private _imageUrl: string;
    public set hasImage(v: boolean) { this._hasImage = v; } public get hasImage(): boolean { return this._hasImage; } private _hasImage: boolean;
    public set unitSelector(v: UnitMultiSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitMultiSelectorViewModel { return this._unitSelector; } private _unitSelector: UnitMultiSelectorViewModel;
    public set productGroupSelector(v: ProductGroupSelectorViewModel) { this._productGroupSelector = v; } public get productGroupSelector(): ProductGroupSelectorViewModel { return this._productGroupSelector; } private _productGroupSelector: ProductGroupSelectorViewModel;
    public set productTypeSelector(v: ProductTypeSelectorViewModel) { this._productTypeSelector = v; } public get productTypeSelector(): ProductTypeSelectorViewModel { return this._productTypeSelector; } private _productTypeSelector: ProductTypeSelectorViewModel;
    public set length(v: number) { this._length = v; } public get length(): number { return this._length; } private _length: number;
    public set width(v: number) { this._width = v; } public get width(): number { return this._width; } private _width: number;
    public set height(v: number) { this._height = v; } public get height(): number { return this._height; } private _height: number;
    public set weight(v: number) { this._weight = v; } public get weight(): number { return this._weight; } private _weight: number;
    public set secondWeight(v: number) { this._secondWeight = v; } public get secondWeight(): number { return this._secondWeight; } private _secondWeight: number;
    public set technicalNumber(v: string) { this._technicalNumber = v; } public get technicalNumber(): string { return this._technicalNumber;} private _technicalNumber: string;
    public set isSafetyMaterial(v: boolean) { this._isSafetyMaterial = v; } public get isSafetyMaterial(): boolean { return this._isSafetyMaterial; } private _isSafetyMaterial: boolean;
    public set isRawMaterial(v: boolean) { this._isRawMaterial = v; } public get isRawMaterial(): boolean { return this._isRawMaterial; } private _isRawMaterial: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;


    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
